<script setup lang="ts">
    defineProps({
        roles: {
            required: true,
        },
    })
</script>

<template>
    <div>
        <v-chip
            v-for="(role, index) in roles"
            :key="index"
            :color="role?.color || 'primary'"
            class="mr-2"
            label
            size="small"
        >
            {{ role?.common_name || role?.name || "Rôle inconnu" }}
        </v-chip>
    </div>
</template>
